import { useQuery } from "react-query";
import { getCarrierPrograms } from "../../../../../actions/Utilities/CarrierProgram/index";

export const useCarrierProgram = () => {
  const { data, isFetching } = useQuery(
    "GetCarrierPrograms",
    getCarrierPrograms,
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );
  return { data, isFetching };
};
